import type { TherapistActivityEvents } from '../machines/therapistActivityMachine';

/**
 * RTM page-view events the machine is sent — the sequences that decide WHICH CLIENT a minute is billed to
 * (`unsavedActivities` → `upsertPracticeUsageEvents`; an activity with no client is dropped). Pure, so the minutes are
 * proven on the machine itself (`machines/therapistActivityMachine.test.ts`).
 */

/**
 * Back to a list after an inline edit ends (Save / Cancel). The list's client rides the event — on the client page
 * (`fixedClientId`) the header's global filter is empty (E57 rule 2), and the machine's fallback to it billed the rest of
 * the visit to nobody (E57 review F7).
 */
export const backToListEvent = (resource: string, clientId?: string | null): TherapistActivityEvents => ({
  type: 'LOADED',
  resource,
  ...(clientId ? { clientId } : {}),
});

/**
 * The page's client changed under a mounted page. The first client (the record arriving after the first render) joins
 * the running activity; a DIFFERENT client (client A → client B on the same page instance: back / forward, Find a
 * client) finishes A's activity for A and starts B's — never re-labels A's elapsed minutes as B's (E57 review F12).
 */
export const clientChangeEvents = (
  resource: string,
  previous: string | null | undefined,
  next: string | null | undefined,
): TherapistActivityEvents[] => {
  if (!next || next === previous) return [];
  if (!previous) return [{ type: 'ENTITY_CLIENT_ID_CHANGED', clientId: next }];
  return [{ type: 'LEFT' }, { type: 'LOADED', resource, clientId: next }];
};
